import { useEffect, type PropsWithChildren } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';
import { db, ensureDefaults } from '@/lib/db';
import { applyTheme, startThemeAutoTicker } from '@/lib/themeEngine';
import { DEFAULT_PREFERENCES } from '@/types/user';
import { InstallPromptIOS } from '@/components/Push/InstallPromptIOS';
import { InstallPromptAndroid } from '@/components/Push/InstallPromptAndroid';
import { NoteDialog } from '@/components/NoteDialog';

export function App({ children }: PropsWithChildren) {
  const prefs = useLiveQuery(() => db.prefs.get('singleton'), [], undefined);

  useEffect(() => {
    void ensureDefaults();
  }, []);

  useEffect(() => {
    if (!prefs) return;
    applyTheme(prefs);
  }, [prefs]);

  useEffect(() => {
    const stop = startThemeAutoTicker(() => prefs);
    return stop;
  }, [prefs]);

  // Watch for SW updates and prompt for refresh
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;
    const onUpdate = () => {
      // Auto-update strategy: just reload silently next time.
    };
    navigator.serviceWorker.addEventListener('controllerchange', onUpdate);
    return () => navigator.serviceWorker.removeEventListener('controllerchange', onUpdate);
  }, []);

  // Initial paint can show the children even before prefs load (theme bootstrap is in index.html).
  void DEFAULT_PREFERENCES;
  return (
    <>
      {children}
      <NoteDialog />
      <InstallPromptIOS />
      <InstallPromptAndroid />
    </>
  );
}
